module.exports = __webpack_public_path__ + "img/mallikuva4.f010e05e.png";